/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Revoked_Data_Retained_DescInputs */



/**
* | output |
* | --- |
* | "Access to the {provider} integration was revoked. The synced data is kept for 30 days so a mistaken revoke can be undone by granting access again, then deleted." |
*
* @param {Audit_Details_Integration_Revoked_Data_Retained_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_revoked_data_retained_desc = /** @type {((inputs: Audit_Details_Integration_Revoked_Data_Retained_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Revoked_Data_Retained_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Zugriff auf die Integration ${i?.provider} wurde entzogen. Die synchronisierten Daten werden 30 Tage aufbewahrt, damit ein versehentlicher Entzug durch erneutes Freigeben rückgängig gemacht werden kann, und danach gelöscht.`)
	return /** @type {LocalizedString} */ (`Access to the ${i?.provider} integration was revoked. The synced data is kept for 30 days so a mistaken revoke can be undone by granting access again, then deleted.`)
});